import { FormControl, FormHelperText } from '@mui/material';
import { TextareaAutosize as BaseTextareaAutosize } from '@mui/base/TextareaAutosize';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { FormInputProps } from './InputInterface';
import DabaduTooltip from 'sharedComponents/toolTip';

const DabaduTextAreaInput = styled(BaseTextareaAutosize)`
  width: 100%;
  height: 120px !important;
  padding: 18px 20px;
  border-radius: 4px;
  font-weight: 300;
  font-size: 1rem;
  letter-spacing: 0;
  line-height: 1.5;
  font-family: ${(props) => props.theme.fonts.primary};
  color: ${(props) => props.theme.colors.textColor};
  border-color: ${(props) => props.theme.colors.inputBorder};
  &:focus {
    border-color: ${(props) => props.theme.colors.inputBorder};
    outline: none;
  }
  @media (max-width: 1650px) {
    padding: 12px 14px;
  }
`;

export const CommonTextAreaInput = ({
  name,
  control,
  label,
  placeholder,
  rules,
  hint,
  type = 'text',
  triggerValidationForField,
  maxRows = 4,
}: FormInputProps) => {
  return (
    <FormControl className='w-100' component='fieldset' required={Boolean(rules)} error={Boolean(rules)}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            {label && (
              <label className='control-label'>
                {label}
                {hint && (
                  <DabaduTooltip title={hint} placement='top-end' className='tooltip-wrapper'>
                    <span>
                      <span className='tooltip-wrapper__text'>i</span>
                    </span>
                  </DabaduTooltip>
                )}
              </label>
            )}
            <DabaduTextAreaInput
              maxRows={maxRows}
              type={type}
              onChange={(e) => {
                onChange(e.target.value);
                triggerValidationForField(name);
              }}
              value={value}
              placeholder={placeholder}
            />
            {Boolean(error?.message) && <FormHelperText>{error?.message}</FormHelperText>}
          </>
        )}
      />
    </FormControl>
  );
};
